// Web-only clipboard helper for the admin console. The console runs in the browser, so we use the
// Clipboard API when present and degrade to a no-op elsewhere (keeps native typecheck/bundle clean —
// no expo-clipboard dependency). Returns whether the copy was attempted.
export async function copyText(value: string): Promise<boolean> {
  const nav = (globalThis as { navigator?: { clipboard?: { writeText(t: string): Promise<void> } } }).navigator;
  if (nav?.clipboard?.writeText) {
    try {
      await nav.clipboard.writeText(value);
      return true;
    } catch {
      return false;
    }
  }
  return false;
}
